import React from 'react';

const PlanTable = ({ stats, formatirajDatum, formatRadnikTekst, ukupnoStatsDnevnica, thStyle, tdStyle }) => {
    return (
        <div style={{overflowX: 'auto', marginTop: '40px'}}>
            <h3 style={{color: '#00ff00', borderBottom: '2px solid #00ff00', paddingBottom: '5px'}}>PLAN RASPOREDA PO VOZILIMA</h3>
            <table style={{width: '100%', borderCollapse: 'collapse', backgroundColor: '#0a132b'}}>
                <thead>
                    <tr>
                        <th style={{...thStyle, width: '120px'}}>DATUM</th>
                        {stats.lista_vozila.map(v => <th key={v.id} style={thStyle}>{v.naziv}</th>)}
                        <th style={{...thStyle, backgroundColor: '#1a2a4a', color: 'white'}}>Σ RADNIKA (DAN)</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(stats.plan_rasporeda).sort().map(datum => {
                        const sumaPoDanu = stats.lista_vozila.reduce((acc, v) => acc + (stats.plan_rasporeda[datum][v.id] || 0), 0);
                        return (
                            <tr key={datum}>
                                <td style={{...tdStyle, fontWeight: 'bold', backgroundColor: '#162447'}}>{formatirajDatum(datum)}</td>
                                {stats.lista_vozila.map(v => (
                                    <td key={v.id} style={tdStyle}>
                                        {formatRadnikTekst(stats.plan_rasporeda[datum][v.id])}
                                    </td>
                                ))}
                                <td style={{...tdStyle, fontWeight: 'bold', backgroundColor: '#1a2a4a', color: '#00ff00'}}>
                                    {sumaPoDanu}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
                <tfoot>
                    <tr style={{backgroundColor: '#162447', fontWeight: 'bold'}}>
                        <td style={tdStyle}>Σ PO VOZILU:</td>
                        {stats.lista_vozila.map(v => {
                            const sumaPoVozilu = Object.keys(stats.plan_rasporeda).reduce((acc, datum) => acc + (stats.plan_rasporeda[datum][v.id] || 0), 0);
                            return <td key={v.id} style={{...tdStyle, color: '#00ff00'}}>{sumaPoVozilu}</td>
                        })}
                        <td style={{...tdStyle, backgroundColor: '#00ff00', color: '#1a2a4a', fontSize: '16px'}}>
                            {ukupnoStatsDnevnica}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
};

export default PlanTable;